<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Overview</h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">A case for support is an important document that explains why your organization or project warrants investment. This document will help your organization communicate a compelling case for why its programs and projects matter, how they will make a difference, why they are needed now, and how they align with your mission. A case for support is essential for successful fundraising, whether it involves philanthropic, investment, or government support.</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">Internally, it serves as a unifying guide that keeps staff, board members, and partners aligned around a clear goal. It helps prevent mission drift, clarifies priorities, and ensures consistent messaging across all outreach and fundraising efforts.</p>

        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 